import { DisplayedType } from 'algolia-api/types/DisplayedTypes';

export const listingTypesBySection = {
  STAFF: [
    'ALL',
    'JOB',
    'INTERNSHIP',
    'VOLOP',
    'ORG',
    'GRAD_PROGRAM',
    'USER',
    'INVOICE',
    'PAYMENT',
    'DONATION',
  ],
  MAIN: ['ALL', 'JOB', 'INTERNSHIP', 'VOLOP', 'ORG', 'GRAD_PROGRAM'],
} satisfies Record<string, Array<DisplayedType>>;
